(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inheritance-blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBlogPosts() {
      var section = document.getElementById('inheritance-blog-posts');
      if (!section) return;
      var overlay = document.getElementById('inheritance-blog-posts-overlay');
      var modal = document.getElementById('inheritance-blog-posts-modal');
      var modalTitle = document.getElementById('inheritance-blog-posts-modal-title');
      var modalBody = document.getElementById('inheritance-blog-posts-modal-body');
      var sheet = document.getElementById('inheritance-blog-posts-sheet');
      var sheetTitle = document.getElementById('inheritance-blog-posts-sheet-title');
      var sheetBody = document.getElementById('inheritance-blog-posts-sheet-body');
      var closeBtn = document.getElementById('inheritance-blog-posts-close');
      var sheetCloseBtn = document.getElementById('inheritance-blog-posts-sheet-close');

      function isMobile() {
        return window.matchMedia('(max-width: 767px)').matches;
      }

      function openArticle(articleId) {
        var contentEl = section.querySelector('#article-content-' + articleId);
        if (!contentEl) return;
        var inner = contentEl.querySelector('.inheritance-blog-posts__full-inner');
        if (!inner) return;
        var titleEl = contentEl.querySelector('.inheritance-blog-posts__full-title');
        var title = titleEl ? titleEl.textContent : '';
        var clone = inner.cloneNode(true);
        var titleInClone = clone.querySelector('.inheritance-blog-posts__full-title');
        if (titleInClone) titleInClone.remove();

        function resetScroll() {
          modalBody.scrollTop = 0;
          sheetBody.scrollTop = 0;
          requestAnimationFrame(function () {
            modalBody.scrollTop = 0;
            sheetBody.scrollTop = 0;
          });
        }

        if (isMobile()) {
          sheetTitle.textContent = title;
          sheetBody.innerHTML = '';
          sheetBody.appendChild(clone);
          resetScroll();
          sheet.hidden = false;
          sheet.classList.add('is-open');
          if (section.querySelector('.inheritance-blog-posts__sheet-backdrop')) {
            section.querySelector('.inheritance-blog-posts__sheet-backdrop').hidden = false;
            section.querySelector('.inheritance-blog-posts__sheet-backdrop').classList.add('is-open');
          }
          document.body.style.overflow = 'hidden';
        } else {
          modalTitle.textContent = title;
          modalBody.innerHTML = '';
          modalBody.appendChild(clone);
          resetScroll();
          overlay.hidden = false;
          overlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      }

      function closeAll() {
        overlay.hidden = true;
        overlay.classList.remove('is-open');
        sheet.hidden = true;
        sheet.classList.remove('is-open');
        var backdrop = section.querySelector('.inheritance-blog-posts__sheet-backdrop');
        if (backdrop) {
          backdrop.hidden = true;
          backdrop.classList.remove('is-open');
        }
        document.body.style.overflow = '';
      }

      section.querySelectorAll('.inheritance-blog-posts__card').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-article-id');
          if (id) openArticle(id);
        });
      });

      var viewport = section.querySelector('.inheritance-blog-posts__viewport');
      var track = document.getElementById('inheritance-blog-posts-list');
      var prevBtn = section.querySelector('.inheritance-blog-posts__arrow--prev');
      var nextBtn = section.querySelector('.inheritance-blog-posts__arrow--next');
      var total = track ? parseInt(track.style.getPropertyValue('--total'), 10) || 0 : 0;
      var current = 0;
      function goTo(index) {
        if (total <= 0 || !track) return;
        current = ((index % total) + total) % total;
        track.style.setProperty('--current', String(current));
      }
      if (prevBtn)
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          goTo(current - 1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          goTo(current + 1);
        });
      if (viewport && total > 0) {
        var swipeStartX = 0;
        var SWIPE_THRESHOLD = 50;
        viewport.addEventListener(
          'touchstart',
          function (e) {
            if (e.touches.length === 1) swipeStartX = e.touches[0].clientX;
          },
          { passive: true }
        );
        viewport.addEventListener(
          'touchend',
          function (e) {
            if (e.changedTouches.length !== 1) return;
            var endX = e.changedTouches[0].clientX;
            var delta = endX - swipeStartX;
            if (delta < -SWIPE_THRESHOLD) goTo(current + 1);
            else if (delta > SWIPE_THRESHOLD) goTo(current - 1);
          },
          { passive: true }
        );
      }

      if (closeBtn) closeBtn.addEventListener('click', closeAll);
      if (sheetCloseBtn) sheetCloseBtn.addEventListener('click', closeAll);
      if (overlay)
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay) closeAll();
        });
      var sheetBackdrop = section.querySelector('.inheritance-blog-posts__sheet-backdrop');
      if (sheetBackdrop) sheetBackdrop.addEventListener('click', closeAll);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBlogPosts);
    else initBlogPosts();

    var sectionEl = document.querySelector('.inheritance-blog-posts');
    if (sectionEl) {
      var canAnimate = false;
      var sectionInView = false;
      function tryAddAnimated() {
        if (canAnimate && sectionInView) sectionEl.classList.add('inheritance-blog-posts--animated');
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sectionInView = entry.isIntersecting;
            tryAddAnimated();
          });
        },
        { rootMargin: '200px 0px -80px 0px', threshold: 0.1 }
      );
      observer.observe(sectionEl);
      function onReady() {
        canAnimate = true;
        tryAddAnimated();
      }
      if (document.getElementById('inheritance-preloader')) {
        window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
      } else {
        if (document.readyState === 'complete') onReady();
        else window.addEventListener('load', onReady, { once: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-cta-contact"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.inheritance-cta');
    if (!section) return;
    var canAnimate = false;
    var sectionInView = false;
    function tryAddAnimated() {
      if (canAnimate && sectionInView) section.classList.add('inheritance-cta--animated');
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sectionInView = entry.isIntersecting;
          tryAddAnimated();
        });
      },
      { rootMargin: '200px 0px -80px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    function onReady() {
      canAnimate = true;
      tryAddAnimated();
    }
    if (document.getElementById('inheritance-preloader')) {
      window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
    } else {
      if (document.readyState === 'complete') onReady();
      else window.addEventListener('load', onReady, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-cta-steps"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.inheritance-cta-steps');
    var canAnimate = false;
    var sectionInView = false;

    function tryAddAnimated() {
      if (canAnimate && sectionInView && section) {
        section.classList.add('inheritance-cta-steps--animated');
      }
    }

    if (section) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sectionInView = entry.isIntersecting;
            tryAddAnimated();
          });
        },
        { rootMargin: '200px 0px -80px 0px', threshold: 0.1 }
      );
      observer.observe(section);
    }

    function onReady() {
      canAnimate = true;
      tryAddAnimated();
    }
    if (document.getElementById('inheritance-preloader')) {
      window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
    } else {
      window.addEventListener('load', onReady, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-expertise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.inheritance-expertise');
    if (!section) return;
    var canAnimate = false;
    var sectionInView = false;
    function tryAddAnimated() {
      if (canAnimate && sectionInView) section.classList.add('inheritance-expertise--animated');
    }
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var rootMargin = isMobile ? '200px 0px 200px 0px' : '200px 0px -80px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sectionInView = entry.isIntersecting;
          tryAddAnimated();
        });
      },
      { rootMargin: rootMargin, threshold: 0.1 }
    );
    observer.observe(section);
    function onReady() {
      canAnimate = true;
      tryAddAnimated();
    }
    if (document.getElementById('inheritance-preloader')) {
      window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
    } else {
      window.addEventListener('load', onReady, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-faq"]) return;
  try {
    
  (function () {
    function initFaqAccordion() {
      var triggers = document.querySelectorAll('[data-faq-trigger]');
      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var expanded = this.getAttribute('aria-expanded') === 'true';
          var targetId = this.getAttribute('aria-controls');
          var content = targetId ? document.getElementById(targetId) : null;
          this.setAttribute('aria-expanded', !expanded);
          if (content) {
            if (expanded) content.setAttribute('hidden', '');
            else content.removeAttribute('hidden');
          }
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFaqAccordion);
    else initFaqAccordion();

    var section = document.querySelector('.inheritance-faq');
    if (section) {
      var canAnimate = false;
      var sectionInView = false;
      function tryAddAnimated() {
        if (canAnimate && sectionInView) section.classList.add('inheritance-faq--animated');
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sectionInView = entry.isIntersecting;
            tryAddAnimated();
          });
        },
        { rootMargin: '200px 0px -80px 0px', threshold: 0.1 }
      );
      observer.observe(section);
      function onReady() {
        canAnimate = true;
        tryAddAnimated();
      }
      if (document.getElementById('inheritance-preloader')) {
        window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
      } else {
        if (document.readyState === 'complete') onReady();
        else window.addEventListener('load', onReady, { once: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initInheritanceForm() {
      var form = document.querySelector('#inheritance-form .inheritance-form__form');
      if (!form) return;
      form.setAttribute('data-shopify-captcha', 'true');
      var decedentState = form.querySelector('#form-decedent-state');
      var yourState = form.querySelector('#form-your-state');
      var share = form.querySelector('#form-share');
      var valueSelect = form.querySelector('#form-value');
      var phoneInput = form.querySelector('[data-phone-format]');
      var submitBtn = form.querySelector('.inheritance-form__submit');

      if (phoneInput) {
        function formatUSPhone() {
          var v = phoneInput.value.replace(/\D/g, '');
          if (v.length > 10) v = v.slice(0, 10);
          if (v.length <= 3) phoneInput.value = v;
          else if (v.length <= 6) phoneInput.value = '(' + v.slice(0, 3) + ') ' + v.slice(3);
          else phoneInput.value = '(' + v.slice(0, 3) + ') ' + v.slice(3, 6) + '-' + v.slice(6);
        }
        phoneInput.addEventListener('input', formatUSPhone);
        phoneInput.addEventListener('paste', function () {
          setTimeout(formatUSPhone, 0);
        });
      }

      var requiredFields = form.querySelectorAll('[data-required]');
      function isFormValid() {
        for (var i = 0; i < requiredFields.length; i++) {
          var el = requiredFields[i];
          var val = el.value ? el.value.trim() : '';
          if (el.type === 'email' && val) {
            var at = val.indexOf('@');
            if (at < 1 || val.indexOf('.', at) < at + 2) return false;
          }
          if (!val) return false;
        }
        return true;
      }
      function updateSubmitButton() {
        var valid = isFormValid();
        submitBtn.disabled = !valid;
        submitBtn.setAttribute('aria-disabled', valid ? 'false' : 'true');
      }
      requiredFields.forEach(function (el) {
        el.addEventListener('input', updateSubmitButton);
        el.addEventListener('change', updateSubmitButton);
      });
      updateSubmitButton();

      function runSubmit() {
        var formInner = form.querySelector('.inheritance-form__form-inner');
        var successState = document.getElementById('inheritance-form-success');
        var errorEl = document.getElementById('inheritance-form-error');
        if (!formInner || !successState || !errorEl) return;

        var firstName = form.querySelector('#contact-first-name');
        var lastName = form.querySelector('#contact-last-name');
        var nameHidden = form.querySelector('#contact-name-hidden');
        if (firstName && lastName && nameHidden) {
          nameHidden.value = (firstName.value.trim() + ' ' + lastName.value.trim()).trim();
        }
        var phone = form.querySelector('#contact-phone');
        if (phone && phone.value) {
          var digits = phone.value.replace(/\D/g, '');
          if (digits.length === 10) phone.value = '+1' + digits;
        }
        var parts = [];
        if (decedentState && decedentState.value) parts.push("Decedent's State of Residence: " + decedentState.value);
        if (yourState && yourState.value) parts.push('Your State of Residence: ' + yourState.value);
        if (share && share.value)
          parts.push(
            'Your Estimated Share of the Estate (%): ' + (share.value === 'unknown' ? 'Unknown' : share.value + '%')
          );
        if (valueSelect && valueSelect.value)
          parts.push('Estimated Value of Your Inheritance ($): ' + valueSelect.options[valueSelect.selectedIndex].text);
        var fullBody = parts.join('\n');

        var formData = new FormData(form);
        formData.set('contact[body]', fullBody);

        var action = form.getAttribute('action') || '';
        if (!action || action.indexOf('/contact') === -1) action = '/contact';
        if (action.indexOf('http') !== 0)
          action = window.location.origin + (action.indexOf('/') === 0 ? action : '/' + action);

        fetch(action, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          redirect: 'follow',
        })
          .then(function (res) {
            var status = res.status;
            if (status >= 200 && status < 300) {
              return res.text().then(function (html) {
                var isSuccess =
                  html.indexOf('form-success') !== -1 || html.indexOf('contact_form') !== -1 || status === 200;
                if (isSuccess) {
                  formInner.setAttribute('hidden', '');
                  successState.removeAttribute('hidden');
                  var rightCol = form.closest('.inheritance-form__right');
                  if (rightCol) rightCol.classList.add('is-success');
                } else {
                  throw new Error('Submit failed');
                }
              });
            }
            throw new Error('Submit failed');
          })
          .catch(function () {
            var dataEl = document.getElementById('inheritance-form-data');
            errorEl.textContent =
              (dataEl && dataEl.getAttribute('data-error-message')) ||
              'Something went wrong. Please try again or contact us directly.';
            errorEl.removeAttribute('hidden');
          })
          .finally(function () {
            submitBtn.classList.remove('is-loading');
            submitBtn.disabled = !isFormValid();
            submitBtn.setAttribute('aria-disabled', submitBtn.disabled ? 'true' : 'false');
            var loaderEl = submitBtn.querySelector('.inheritance-form__submit-loader');
            if (loaderEl) loaderEl.setAttribute('hidden', '');
          });
      }

      function doSubmit() {
        if (!isFormValid()) return;
        var formInner = form.querySelector('.inheritance-form__form-inner');
        var successState = document.getElementById('inheritance-form-success');
        var errorEl = document.getElementById('inheritance-form-error');
        if (!formInner || !successState || !errorEl) return;

        errorEl.setAttribute('hidden', '');
        errorEl.textContent = '';

        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        var loaderEl = submitBtn.querySelector('.inheritance-form__submit-loader');
        if (loaderEl) loaderEl.removeAttribute('hidden');

        if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
          window.Shopify.captcha.protect(form, runSubmit);
        } else {
          runSubmit();
        }
      }

      submitBtn.addEventListener('click', function () {
        doSubmit();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initInheritanceForm);
    else initInheritanceForm();

    var sectionEl = document.querySelector('.inheritance-form');
    if (sectionEl) {
      var canAnimate = false;
      var sectionInView = false;
      function tryAddAnimated() {
        if (canAnimate && sectionInView) sectionEl.classList.add('inheritance-form--animated');
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sectionInView = entry.isIntersecting;
            tryAddAnimated();
          });
        },
        { rootMargin: '200px 0px -80px 0px', threshold: 0.1 }
      );
      observer.observe(sectionEl);
      function onReady() {
        canAnimate = true;
        tryAddAnimated();
      }
      if (document.getElementById('inheritance-preloader')) {
        window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
      } else {
        if (document.readyState === 'complete') onReady();
        else window.addEventListener('load', onReady, { once: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-hero"]) return;
  try {
    
  (function () {
    var HIDE_THRESHOLD = 180;
    var inFlow = document.getElementById('inheritance-header-in-flow');
    var fixedWrap = document.getElementById('inheritance-header-fixed');
    if (!inFlow || !fixedWrap) return;

    var lastScrollY = window.scrollY || window.pageYOffset;

    function updateStickyHeader() {
      var scrollY = window.scrollY || window.pageYOffset;
      var scrollingUp = scrollY < lastScrollY;
      lastScrollY = scrollY;

      var rect = inFlow.getBoundingClientRect();
      var pastHeader = rect.bottom < 0;
      var inApproachZone = rect.top >= 0 && rect.top < HIDE_THRESHOLD;
      var showSticky = pastHeader && !inApproachZone && scrollingUp;

      if (showSticky) {
        fixedWrap.classList.add('is-visible');
        fixedWrap.removeAttribute('hidden');
        fixedWrap.setAttribute('aria-hidden', 'false');
      } else {
        fixedWrap.classList.remove('is-visible');
        fixedWrap.setAttribute('hidden', '');
        fixedWrap.setAttribute('aria-hidden', 'true');
      }
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          updateStickyHeader();
          ticking = false;
        });
        ticking = true;
      }
    }
    updateStickyHeader();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-reviews"]) return;
  try {
    
  (function () {
    var SWIPE_THRESHOLD = 50;
    var section = document.getElementById('success-stories');
    if (section) {
      var canAnimate = false;
      var sectionInView = false;
      function tryAddAnimated() {
        if (canAnimate && sectionInView) section.classList.add('inheritance-reviews--animated');
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sectionInView = entry.isIntersecting;
            tryAddAnimated();
          });
        },
        { rootMargin: '200px 0px -80px 0px', threshold: 0.1 }
      );
      observer.observe(section);
      function onReady() {
        canAnimate = true;
        tryAddAnimated();
      }
      if (document.getElementById('inheritance-preloader')) {
        window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
      } else {
        window.addEventListener('load', onReady, { once: true });
      }
    }

    function initReviewsSlider() {
      var section = document.getElementById('success-stories');
      if (!section) return;
      var viewport = section.querySelector('.inheritance-reviews__viewport');
      var track = section.querySelector('.inheritance-reviews__track');
      var prevBtn = section.querySelector('.inheritance-reviews__arrow--prev');
      var nextBtn = section.querySelector('.inheritance-reviews__arrow--next');
      var currentEls = section.querySelectorAll('.inheritance-reviews__current');
      var slides = section.querySelectorAll('.inheritance-reviews__slide');
      if (!track) return;
      var total = parseInt(track.style.getPropertyValue('--total'), 10) || 0;
      if (total <= 0) return;
      var current = 0;
      function goTo(index) {
        current = ((index % total) + total) % total;
        track.style.setProperty('--current', String(current));
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === current);
        });
        if (currentEls.length) {
          currentEls.forEach(function (el) {
            el.textContent = String(current + 1);
          });
        }
      }
      if (prevBtn)
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          goTo(current - 1);
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          goTo(current + 1);
        });
      section.addEventListener('click', function (e) {
        var target =
          e.target &&
          (e.target.closest('.inheritance-reviews__arrow--prev') ||
            e.target.closest('.inheritance-reviews__arrow--next'));
        if (!target) return;
        e.preventDefault();
        if (target.classList.contains('inheritance-reviews__arrow--prev')) goTo(current - 1);
        else goTo(current + 1);
      });

      if (viewport) {
        var startX = 0;
        viewport.addEventListener(
          'touchstart',
          function (e) {
            if (e.touches.length === 1) startX = e.touches[0].clientX;
          },
          { passive: true }
        );
        viewport.addEventListener(
          'touchend',
          function (e) {
            if (e.changedTouches.length !== 1) return;
            var endX = e.changedTouches[0].clientX;
            var delta = endX - startX;
            if (delta < -SWIPE_THRESHOLD) goTo(current + 1);
            else if (delta > SWIPE_THRESHOLD) goTo(current - 1);
          },
          { passive: true }
        );
      }

      var autoAdvanceMs = 5500;
      var autoTimer = null;
      if (total > 1) {
        autoTimer = setInterval(function () {
          goTo(current + 1);
        }, autoAdvanceMs);
      }
      function pauseAuto() {
        if (autoTimer) {
          clearInterval(autoTimer);
          autoTimer = null;
        }
      }
      function resumeAuto() {
        if (!autoTimer && total > 1) {
          autoTimer = setInterval(function () {
            goTo(current + 1);
          }, autoAdvanceMs);
        }
      }
      if (typeof document.hidden !== 'undefined') {
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) pauseAuto();
          else resumeAuto();
        });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReviewsSlider);
    else initReviewsSlider();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-team"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.inheritance-team');
    if (!section) return;
    var canAnimate = false;
    var sectionInView = false;
    function tryAddAnimated() {
      if (canAnimate && sectionInView) section.classList.add('inheritance-team--animated');
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sectionInView = entry.isIntersecting;
          tryAddAnimated();
        });
      },
      { rootMargin: '200px 0px -80px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    function onReady() {
      canAnimate = true;
      tryAddAnimated();
    }
    if (document.getElementById('inheritance-preloader')) {
      window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
    } else {
      if (document.readyState === 'complete') onReady();
      else window.addEventListener('load', onReady, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inheritance-video"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.inheritance-video');
    if (!section) return;
    var canAnimate = false;
    var sectionInView = false;
    function tryAddAnimated() {
      if (canAnimate && sectionInView) section.classList.add('inheritance-video--animated');
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sectionInView = entry.isIntersecting;
          tryAddAnimated();
        });
      },
      { rootMargin: '200px 0px -80px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    function onReady() {
      canAnimate = true;
      tryAddAnimated();
    }
    if (document.getElementById('inheritance-preloader')) {
      window.addEventListener('inheritancePreloaderDone', onReady, { once: true });
    } else {
      window.addEventListener('load', onReady, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
